// src/pages/ParasutFaturaGonder.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../pages/ParasutFaturaGonder.css';

const ParasutFaturaGonder = () => {
  const [kayitlar, setKayitlar] = useState([]);
  const [secili, setSecili] = useState(null);
  const [mesaj, setMesaj] = useState('');

  useEffect(() => {
    const veriler = JSON.parse(localStorage.getItem('kompresorKayitlari')) || [];
    setKayitlar(veriler);
  }, []);

  const handleFaturaGonder = async (data) => {
    const token = localStorage.getItem('parasut_token');
    if (!token) {
      setMesaj('❌ Lütfen önce Parasut bağlantısını tamamlayın.');
      return;
    }

    const faturaData = {
      data: {
        type: "sales_invoices",
        attributes: {
          item_type: "invoice",
          description: `MOON X24 Teklif Faturası - ${data.model}`,
          issue_date: new Date().toISOString().split('T')[0],
          due_date: new Date().toISOString().split('T')[0],
          currency: "TRL",
          exchange_rate: 1,
          with_holdings: false,
          invoice_series: "MX24",
          contact_name: data.firma,
          details: [
            {
              description: `${data.model} (${data.seriNo})`,
              quantity: 1,
              unit_price: 1000
            }
          ]
        }
      }
    };

    try {
      const response = await axios.post(
        'https://api.parasut.com/v4/175236/sales_invoices',
        faturaData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/vnd.api+json'
          }
        }
      );
      setSecili(data);
      setMesaj(`✅ Başarıyla gönderildi! Fatura No: ${response.data.data.attributes.invoice_number}`);
    } catch (err) {
      setMesaj('❌ Fatura gönderimi başarısız.');
      console.error(err);
    }
  };

  return (
    <div className="fatura-gonder-container">
      <h2>📤 Paraşüt'e Teklif Gönder</h2>
      {mesaj && <p className="mesaj">{mesaj}</p>}
      <div className="fatura-kartlar">
        {kayitlar.map((kayit, i) => (
          <div key={i} className="fatura-kart">
            <p><strong>Firma:</strong> {kayit.firma}</p>
            <p><strong>Model:</strong> {kayit.model}</p>
            <p><strong>Seri No:</strong> {kayit.seriNo}</p>
            <button onClick={() => handleFaturaGonder(kayit)}>
              🚀 Gönder
            </button>
          </div>
        ))}
        {kayitlar.length === 0 && <p>📭 Hiç teklif verisi bulunamadı.</p>}
      </div>

      {secili && (
        <div className="fatura-detay">
          <h3>📘 Gönderilen Fatura</h3>
          <p><strong>Firma:</strong> {secili.firma}</p>
          <p><strong>Model:</strong> {secili.model}</p>
          <p><strong>Seri No:</strong> {secili.seriNo}</p>
        </div>
      )}
    </div>
  );
};

export default ParasutFaturaGonder;
